import PartitionApi from "../Classes/API/PartitionApi";
import BuildingApi from "../Classes/API/BuildingApi";

export const loadPartitions = async (inputValue = "", showInactive = false) => {
  try {
    const res = await PartitionApi.GetPartitions({
      name: inputValue,
      showInactive: showInactive,
    });
    return (
      res?.data?.list?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      })) || []
    );
  } catch (error) {
    return [];
  }
};

export const loadBuildings = async (inputValue = "", showInactive = false) => {
  try {
    const res = await BuildingApi.GetBuildings({
      name: inputValue,
      showInactive: false,
    });
    return (
      res?.data?.list?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      })) || []
    );
  } catch (error) {
    return [];
  }
};
